const DIAGRAM_SIZES = {
  COLUMN_GAP_PX: 30,
  ARROW_SIZE_PX: 10,
  MIN_COLUMNS: 3,
};

export default DIAGRAM_SIZES;
